import { z } from 'zod';
import { bindUnvalidatableInputMaker } from '../util.make-unvalidatable-input.js';

const makeUnvalidatableInput = bindUnvalidatableInputMaker();
const markWordsWhitespaceInput = makeUnvalidatableInput({
  schema: z.object({
    type: z.literal("Whitespace"),
    text: z.string()
  }).transform(it => ({
    id: "whitespace",
    type: "Whitespace",
    nodeType: "mark-words-whitespace",
    as: it.text === " " ? "space" : "newline"
  }))
});

export { markWordsWhitespaceInput };
//# sourceMappingURL=input.whitespace.js.map
